import { render, staticRenderFns } from "./AudioWaves.vue?vue&type=template&id=1fa97e94&"
import script from "./AudioWaves.vue?vue&type=script&lang=js&"
export * from "./AudioWaves.vue?vue&type=script&lang=js&"
import style0 from "./AudioWaves.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fa97e94')) {
      api.createRecord('1fa97e94', component.options)
    } else {
      api.reload('1fa97e94', component.options)
    }
    module.hot.accept("./AudioWaves.vue?vue&type=template&id=1fa97e94&", function () {
      api.rerender('1fa97e94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AudioWaves.vue"
export default component.exports